import styled from 'styled-components';

// Trusted-SVG host for the More seed's inline icon strings (seed data only — never user input).
// Mirrors features/communities/CommunityIcon. The wrapper sizes the SVG and inherits currentColor.
const Wrap = styled.span<{ $size: number }>`
  display: inline-flex;
  width: ${({ $size }) => $size}px;
  height: ${({ $size }) => $size}px;
  color: inherit;
  svg { width: 100%; height: 100%; display: block; }
`;

export function MoreIcon({ svg, size = 20 }: { svg: string; size?: number }) {
  return <Wrap $size={size} aria-hidden dangerouslySetInnerHTML={{ __html: svg }} />;
}
